export const endpoints = {
  projects: 'api/web/list/projects',
  suggestedProjects: '/api/web/search/projects',
};
